'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------- Component
/**
  * GeneralMeta - General meta tag
  *
  * @example
    <GeneralMeta data={data} />
  *
  * @param {string} data.description - Required. Description of the webpage. Include a summary of the content on the webpage.
  * @param {string} data.keywords - Required. A set of words that describe the webpage. Minimum 3 words, maximum 10.
  * @param {string} data.image - Required. A unique banner image for the webpage.
  * 
  * @version 0.0.1
  * @todo none
  */
var GeneralMeta = function GeneralMeta(props) {
  return _react2.default.createElement(_reactHelmet2.default, {
    meta: [
    // ---- General SEO
    { name: 'description', content: props.data.description }, { name: 'keywords', content: props.data.keywords }, { name: 'image', content: props.data.image }]
  });
}; // ----------------------------------------------------------------------- Imports


GeneralMeta.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
} : {};

GeneralMeta.defaultProps = {
  data: {}
};

// ----------------------------------------------------------------------- Export
exports.default = GeneralMeta;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/seo/lib/GeneralMeta.js
// module id = 453
// module chunks = 168707334958949